"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DesignInteractionEnum_1 = __importDefault(require("./DesignInteractionEnum"));
var OtherEventsEnum;
(function (OtherEventsEnum) {
    OtherEventsEnum["start"] = "start";
    OtherEventsEnum["addToCart"] = "add_to_cart";
    OtherEventsEnum["addToWishList"] = "add_to_wishlist";
    OtherEventsEnum["initiatePlanningSession"] = "initiate_planning_session";
    OtherEventsEnum["connectApplication"] = "connect_application";
    OtherEventsEnum["pageview"] = "pageview";
    OtherEventsEnum["articleAction"] = "article_action";
    OtherEventsEnum["userFlow"] = "user_flow";
})(OtherEventsEnum || (OtherEventsEnum = {}));
const InsightsEventEnum = Object.assign(Object.assign({}, OtherEventsEnum), DesignInteractionEnum_1.default);
exports.default = InsightsEventEnum;
//# sourceMappingURL=InsightsEventEnum.js.map